<template>
    <div class="container px-1 py-5">
        <div class="flex flex-col items-start justify-between mb-10 md:flex-row md:items-center">
            <div class="flex flex-col mb-5 md:mb-0 md:flex-row md:items-center w-full">
                <h1 class="lg:text-3xl mb-5 md:mb-0 mr-10 text-2xl">
                    {{ __('Kiving Státusz Riport') }}
                </h1>
            </div>
        </div>

        <div class="flex items-center">
            <c-control-date class="max-w-xs mr-10 w-full"
                            icon="calendar"
                            icon-position="right"
                            name="interval"
                            multi-calendars
                            range
                            v-bind:formats="{ input: localizationStore.dateFormat }"
                            v-bind:time-config="{ enableTimePicker: false }"
                            v-model="interval"
            />

            <c-button class="bg-highlight p-4 shrink-0 !text-sm text-white" v-on:click="exportXls">
                <c-icon class="h-5 mr-2 stroke-white w-5" icon="download-cloud" />
                {{ __('Download') }}
            </c-button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import {
        CButton,
        CControlDate,
        CIcon,
    } from '@teamfurther/cinderblock';
    import { useLocalizationStore } from '../../../../stores/localization';
    import { useRequestStore } from '../../../../stores/request';

    const localizationStore = useLocalizationStore();
    const requestStore = useRequestStore();
    const interval = ref();

    async function exportXls() {
        const start = new Date(interval.value[0]).toISOString().split('T')[0];
        const end = new Date(interval.value[1]).toISOString().split('T')[0];
        const response = await requestStore.get(
            't/abl/reports/kiving/export?start=' + start + '&end=' + end,
            { responseType: 'blob' },
        );

        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'export.csv';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }
</script>
